import { Price } from '@artosera/ui';
import type { Langue } from '@artosera/shared';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import type { FacturePresentee } from '../../api/ventes.js';
import styles from './TotauxFacture.module.css';

/** Totaux d'une facture ou d'un avoir : les mêmes en Ventes et dans l'archive légale. */
export function TotauxFacture({
  facture,
  langue,
}: {
  facture: FacturePresentee;
  langue: Langue;
}): JSX.Element {
  const { t } = useTranslation(['ventes', 'regie']);
  const prix = (cents: number, size?: 'lg') => (
    <Price cents={cents} lang={langue} currency={facture.devise} {...(size ? { size } : {})} />
  );
  return (
    <dl className={styles.totaux}>
      <div>
        <dt>{t('ventes:totaux.totalHt')}</dt>
        <dd>{prix(facture.totaux.totalHtCentimes)}</dd>
      </div>
      {facture.totaux.parCategorieTva.map((categorie) => (
        <div key={`${categorie.regime}-${String(categorie.tauxPointsDeBase)}`}>
          <dt>{t(`ventes:regimes.${categorie.regime}`)}</dt>
          <dd>{prix(categorie.tvaCentimes)}</dd>
        </div>
      ))}
      {facture.totaux.droitDeSuiteCentimes > 0 ? (
        <div>
          <dt>
            {t('ventes:totaux.droitDeSuite')}
            {!facture.droitDeSuiteAChargeAcheteur
              ? ` (${t('regie:ventes.fiche.droitDeSuiteGalerie')})`
              : ''}
          </dt>
          <dd>{prix(facture.totaux.droitDeSuiteCentimes)}</dd>
        </div>
      ) : null}
      <div className={styles.totalPrincipal}>
        <dt>{t('ventes:totaux.totalTtc')}</dt>
        <dd>{prix(facture.totaux.totalTtcCentimes, 'lg')}</dd>
      </div>
    </dl>
  );
}
